import { ModelBase, observable } from "@shoothill/core";
import { action } from "mobx";

export class InductionAdminNonConformanceListModel extends ModelBase<InductionAdminNonConformanceListModel> {
    public id: string = "";
    @observable
    public nonConformanceTypeName: string = "";
    @observable
    public nonConformanceNumber: string = "";
    @observable
    public completedByUserName: string = "";
    @observable
    public lastUpdatedDate: string = "";
    @observable
    public lastUpdatedByUserName: string = "";
    @observable
    public projectId: string = "";

    constructor() {
        super();
    }

    @action
    public referenceNumber = (item: any) => {
        let formattedNumber = item.toLocaleString("en-US", {
            minimumIntegerDigits: 8,
            useGrouping: false,
        });
        return formattedNumber;
    };

    fromDto(model: InductionAdminNonConformanceListDTO): void {
        this.id = model.id;
        this.nonConformanceTypeName = model.nonConformanceTypeName;
        this.nonConformanceNumber = model.nonConformanceNumber;
        this.completedByUserName = model.completedByUserName;
        this.lastUpdatedDate = model.lastUpdatedDate;
        this.lastUpdatedByUserName = model.lastUpdatedByUserName;
        this.projectId = model.projectId;
    }
    toDto(model: InductionAdminNonConformanceListModel): void {
        throw new Error("Method not implemented.");
    }
}

export interface InductionAdminNonConformanceListDTO {
    id: string;
    nonConformanceTypeName: string;
    nonConformanceNumber: string;
    completedByUserName: string;
    lastUpdatedDate: string;
    lastUpdatedByUserName: string;
    projectId: string;
}

export interface InductionAdminNonConformanceTypeDTO {
    id: string;
    displayName: string;
    type: number;
    ordinal: number;
    isDeleted: boolean;
}

export interface InductionAdminNonConformanceAndRelatedDTO {
    nonConformanceListItems: InductionAdminNonConformanceListDTO[];
    nonConformanceTypes: InductionAdminNonConformanceTypeDTO[];
}
